import { cargoes } from '../entities/cargoes-sidecar'
import { machines } from '../machines/machines-sidecar'
import { IMonster } from '../monsters/monsters'
import { IJobCreator } from '../behavior/jobCreators'
import { jobCreators } from '../behavior/jobCreators-sidecar'
import { jobs } from '../behavior/jobs-sidecar'

export function create(obj: IMonster) {
  let jcs: IJobCreator[] = []
  let jc: IJobCreator | null = null

  if (obj.type === 'slime') {
    // Consume cargo

    jc = jobCreators.create(
      () => {
        let cg = cargoes.findClosestTo(obj.i, obj.j, (c) => true)
        if (!cg) {
          return false
        }
        return true
      },
      () => {
        let j = jobs.create('eat', 0)
        obj.statHunger = 0
        j.cargoFilter = (f) => true // Eat anything
        j.onlyFor = obj
        return j
      },
    )
    jcs.push(jc)
  }

  if (obj.type === 'human') {
    // Take off suit
    jc = jobCreators.create(
      () => {
        if (!obj.isInsideShip || !obj.isInSuit) {
          return false
        }
        return true
      },
      () => {
        let j = jobs.create('take-off-suit')
        j.onlyFor = obj
        return j
      },
    )
    jcs.push(jc)

    // Put away item
    jc = jobCreators.create(
      () => {
        if (!obj.carryingCargo) {
          return false
        }
        return true
      },
      () => {
        let j = jobs.create('put-away-carried-cargo')
        j.onlyFor = obj
        return j
      },
    )
    jcs.push(jc)

    // Drink
    jc = jobCreators.create(
      () => {
        if (obj.statThirst > 33) {
          return false
        }
        if (
          !machines.findClosestTo(
            obj.i,
            obj.j,
            (c) => c.data.type === 'water-cooler' && c.waterSupply > 0,
          )
        ) {
          return false
        }
        return true
      },
      () => {
        let j = jobs.create('drink')
        j.onlyFor = obj
        return j
      },
    )
    jcs.push(jc)

    // Eat
    jc = jobCreators.create(
      () => {
        if (obj.statHunger > 33) {
          return false
        }
        if (
          !cargoes.findClosestTo(obj.i, obj.j, (c) => c.data.type === 'food')
        ) {
          return false
        }
        return true
      },
      () => {
        let j = jobs.create('eat')
        j.onlyFor = obj
        return j
      },
    )
    jcs.push(jc)

    // Sleep
    jc = jobCreators.create(
      () => {
        if (obj.statEnergy > 33) {
          return false
        }
        if (
          !machines.findClosestTo(
            obj.i,
            obj.j,
            (c) => c.data.type === 'bed' && c.isOccupied === false,
          )
        ) {
          return false
        }
        return true
      },
      () => {
        let j = jobs.create('sleep')
        j.onlyFor = obj
        return j
      },
    )
    jcs.push(jc)

    // Idle
    jc = jobCreators.create(
      () => {
        if (obj.idleTimer < 60) {
          return false
        }
        if (
          !machines.findClosestTo(obj.i, obj.j, (c) => c.data.type === 'table')
        ) {
          return false
        }
        return true
      },
      () => {
        let j = jobs.create('idle')
        j.onlyFor = obj
        obj.idleTimer = 0
        return j
      },
    )
    jcs.push(jc)
  }

  return jcs
}
